const INITIAL_URL_VALUE = '';

export interface AuthConfigState {
  registerInitURL: string;
  registerActionURL: string;
  registerPollURL: string;
  loginInitURL: string;
  loginActionURL: string;
  loginPollURL: string;
  pollingIntervalSeconds: number;
  sentConfirmLink?: boolean;
}

const initialState: AuthConfigState = {
  registerInitURL: INITIAL_URL_VALUE,
  registerActionURL: INITIAL_URL_VALUE,
  registerPollURL: INITIAL_URL_VALUE,
  loginInitURL: INITIAL_URL_VALUE,
  loginActionURL: INITIAL_URL_VALUE,
  loginPollURL: INITIAL_URL_VALUE,
  pollingIntervalSeconds: 0,
};

export default initialState;
